import { Typography } from '@recruit-robin/robin-theme/web-components';
import { motion } from 'motion/react';

import { buttonVariants, useStyles } from './Header.styles';

const HeaderTitle = ({ name, profiles }: { name: React.ReactNode; profiles: React.ReactNode }) => {
  const classes = useStyles();
  return (
    <div css={classes.sourceContainer}>
      {profiles}
      <Typography variant={(v) => v.heading[5]} color={(c) => c.neutral.variant[80]} inline>
        {name}
      </Typography>
    </div>
  );
};

export const Header = ({
  title,
  subtitle,
  buttons,
}: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  buttons: React.ReactNode;
}) => {
  const classes = useStyles();

  return (
    <div css={classes.header}>
      <div css={classes.title}>
        {title}
        <motion.div css={classes.buttonsContainer} variants={buttonVariants} onClick={(e) => e.stopPropagation()}>
          {buttons}
        </motion.div>
      </div>
      {subtitle && <div css={classes.subtitle}>{subtitle}</div>}
    </div>
  );
};

Header.Title = HeaderTitle;
